import { ConfirmationModalContent } from '@dealstack/frontend/shared/components/ConfirmationModal/ConfirmationModalContent';
import { memo } from 'react';
import ReactModal from 'react-modal';
import { IAlertProps } from '@dealstack/frontend/shared/components/Alert/Alert.types';

interface Props {
	title: string;
	description: React.ReactNode;
	children?: React.ReactNode;
	state?: IAlertProps['state'];
}

const ConfirmationModalV3 = ({ title, description, children, state }: Props) => {
	return (
		<ReactModal
			contentLabel="confirmation-modal-v3"
			isOpen
			className="ReactModal__Content"
			style={{ content: { maxWidth: 'fit-content' } }}
		>
			<ConfirmationModalContent title={title} description={description} state={state}>
				{children}
			</ConfirmationModalContent>
		</ReactModal>
	);
};
const _ConfirmationModalV3Export = memo(ConfirmationModalV3);

export { _ConfirmationModalV3Export as ConfirmationModalV3 };
